import { ResponseData } from "./tunnel-message-data";

/**
 * @hidden
 */
export interface AlertResponse extends ResponseData {
    type: '@stemcstudio/modal-dialog-service:alert-response';
    value?: boolean;
}

/**
 * @hidden
 */
export function isAlertResponse(message: MessageEvent): message is MessageEvent<AlertResponse> {
    const duck = message as MessageEvent<AlertResponse>;
    if (duck.data.type && duck.data.type === '@stemcstudio/modal-dialog-service:alert-response') {
        return true;
    } else {
        return false;
    }
}
